import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=fd73546c&scoped=true"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=fd73546c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd73546c",
  null
  
)

export default component.exports